import { render } from "./CreateAppointmentTypeModal.vue?vue&type=template&id=0850e09a&scoped=true"
import script from "./CreateAppointmentTypeModal.vue?vue&type=script&lang=js"
export * from "./CreateAppointmentTypeModal.vue?vue&type=script&lang=js"

import "./CreateAppointmentTypeModal.vue?vue&type=style&index=0&id=0850e09a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0850e09a"]])

export default __exports__